<template>
  <div class="Chat">
    <van-nav-bar title="选择聊天" fixed border @click-left="onClickLeft" class="new">
      <template #left>
        <img src="../../assets/img/icon/left-arrow.png" class="icon" />
      </template>
    </van-nav-bar>
    <van-swipe-cell v-if="sortChatList.length==0">
    	<div class="empty">
			<span class="msg">暂无消息，到通讯录找人聊聊吧!</span>
		</div>
    </van-swipe-cell>
    <van-swipe-cell v-for="(item, index) in sortChatList" v-else :key="index" :id="item.ug_id">
      <!--群聊-->
      <template v-if="item.ug_id">
        <van-swipe-cell>
          <div
            :class="getGroupStick(item.ug_id) == 1 ?'gray':'van-cell-div'"
            @click="groupChatroom(item.ug_id, item.ug_name,m_post_messages,m_type1)"
          >
            <van-image
              class="err-image-header"
              round
              width="45px"
              height="45px"
              :src="attach_url+item.ug_icon"
            ></van-image>
            <span v-for="(it,index) in groupValue" :key="index+'c'" class="tag1"></span>
            <div class="cell-group">
              <van-cell :title="item.ug_name"></van-cell>
              <!-- :value="item.create_time*1000|moment_format('Y-M-D HH:mm:ss')" -->
              <van-cell class="van-c-t" title-class="van-ellipsis">
                <template slot="title" v-if="item.ug_type == 'text'">
                  <span
                    v-html="item.ug_group_nick?item.ug_group_nick+'：'+ item.gm_content:item.u_nickname?item.u_nickname+'：' + item.gm_content:item.u_login_id+'：' + item.gm_content"
                  ></span>
                </template>
                <template slot="title" v-else-if="item.ug_type == 'notice'">
                  <span>{{item.gm_content}}</span>
                </template>
                <template slot="title" v-else-if="item.ug_type == 'video'">
                  <span>[视频]</span>
                </template>
                <template slot="title" v-else-if="item.ug_type == 'audio'">
                  <span>[语音]</span>
                </template>
                <template slot="title" v-else>
                  <span>{{item.ug_group_nick?item.ug_group_nick+'：'+'[图片]':item.u_nickname?item.u_nickname+'：'+'[图片]':item.u_login_id+'：'+'[图片]'}}</span>
                </template>
              </van-cell>
            </div>
          </div>
        </van-swipe-cell>
      </template>
      <!--单聊-->
      <template v-else>
        <van-swipe-cell>
          <div
            :class="gatStick(item.uid) == 1?'gray':'van-cell-div'"
            @click="enterTheChat(item.uid,item.f_name?item.f_name:item.u_nickname?item.u_nickname:item.u_login_id,m_post_messages,m_type1)"
          >
            <van-image
              class="err-image-header"
              round
              width="45px"
              height="45px"
              :src="attach_url+item.u_headportrait"
            />
            <span v-for="(it,index) in chatvalue" :key="index+'a'" class="tag1"></span>
            <div class="cell-group">
              <van-cell
                :title="item.f_name?item.f_name:item.u_nickname?item.u_nickname:item.u_login_id"
              ></van-cell>
              <!-- :value="item.create_time*1000|moment_format('Y-M-D HH:mm:ss')" -->
              <van-cell class="van-c-t" title-class="van-ellipsis" info="5">
                <template slot="title" v-if="item.m_type == 'text'">
                  <span v-html="item.m_post_messages"></span>
                </template>
                <template slot="title" v-else-if="item.m_type == 'video'">
                  <span>[视频]</span>
                </template>
                <template slot="title" v-else-if="item.m_type == 'audio'">
                  <span>[语音]</span>
                </template>
                <template slot="title" v-else>
                  <span>[图片]</span>
                </template>
                <van-icon
                  v-if="getNoDisturbing(item.uid) == 1"
                  slot="right-icon"
                  name="/static/icon/avoid.png"
                  style="line-height: inherit;"
                  size="20px"
                />
              </van-cell>
            </div>
          </div>
        </van-swipe-cell>
      </template>
      <!-- 群聊 -->
    </van-swipe-cell>
  </div>
</template>
<script type='text/ecmascript-6'>
export default {
  name: "Commonchat",
  data() {
    return {
      chatvalue: 0,
      groupValue: 0,
      chatList: "",
      sortChatList: [],
      agent: "",
      url: this.Conf.registUrl,
      u_code: "",
      socket: "",
      loading: false,
      finished: false,
      show: false,
      u_id: localStorage.getItem("u_id"),
      token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
      attach_url: this.Conf.serverPre,
      defaultImg: 'this.src=\\"' + require("../../assets/logo.png") + '\\"',
      ug_id: "",
      // socket长连接以下为新链接
      Socket: "",
      lockReconnect: false, //是否真正建立连接
      timeout: 20000, //20秒一次心跳
      timeoutObj: null, //心跳心跳倒计时
      serverTimeoutObj: null, //心跳倒计时
      timeoutnum: null, //断开 重连倒计时,
      m_post_messages: "",
      userinfo: JSON.parse(localStorage.getItem("userInfo")),
      transtat: 1,
      rannumber: 1,
      m_type1:"",
      duration:""
    };
  },
  created() {
    if (!this.u_id) {
      this.$router.push({
        path: "/login"
      });
    }
		this.getStateConfigs();
    this.chkSocketState();
    // 初始化
    if (this.u_id && this.token) {
      this.loadData();
    }
    var query = this.$route.query;
    this.m_post_messages = query.m_post_messages;
    this.m_type1 = query.m_type;
    this.duration = query.duration;
  },
  methods: {
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        for (let i = 0; i < this.list.length; i++) {
          this.list.push(this.list.length + 1);
        }
        // 加载状态结束
        this.loading = false;
        // 数据全部加载完成
        if (this.list.length >= 10) {
          this.finished = true;
        }
      }, 500);
    },
    chkSocketState() {
      if (
        this.websocket &&
        this.websocket.ws &&
        this.websocket.ws.readyState == 1
      ) {
        // 监听socket连接
        this.websocket.ws.onopen = this.open;
        // 监听socket错误信息
        this.websocket.ws.onerror = this.error;
        // 监听消息回调
        this.websocket.ws.onmessage = this.getMessage;
        // 监听连接关闭
        this.websocket.ws.onclose = this.close;
        return true;
      } else {
        this.reconnect();
        return false;
      }
    },
    loadData() {
      // 单聊天记录
      var par = {
        u_id: this.u_id,
        token: this.token,
        num: Math.random()
      };
      var url = this.Conf.serverUrl + "Messages/getMessagesList";
      this.$axios
        .post(url, this.$qs.stringify(par))
        .then(response => {
          this.sortChatList = this.sortByKey(
            response.data.chatroomMsg,
            "sorting"
          );
        })
        .catch(error => {});
      this.chatvalue = JSON.parse(localStorage.getItem("unread"));
      this.groupValue = JSON.parse(localStorage.getItem("groupUnread"));
    },
    // 数组对象排序  array数组  key 数组对象中的key 升序降序修改大于小于号
    sortByKey(array, key) {
      return array.sort(function(a, b) {
        var x = a[key];
        var y = b[key];
        return x > y ? -1 : x < y ? 1 : 0;
      });
    },
    // 群聊免打扰图标
    getGroupNoDistrrbing(ug_id) {
      return localStorage.getItem(ug_id + "groupNoDistrrbing");
    },
    // 单聊免打扰图标
    getNoDisturbing(uid) {
      return localStorage.getItem(uid + "noDisturbing");
    },
    // 群置顶图标
    getGroupStick(ug_id) {
      return localStorage.getItem(ug_id + "groupStick");
    },
    // // 单聊置顶图标
    gatStick(uid) {
      return localStorage.getItem(uid + "stick");
    },
    // // 监听socket消息回调
    getMessage(msg) {
      //收到服务器任何信息，心跳重置
      var that = this;
      var data = JSON.parse(msg.data);
      switch (data.status) {
        case 1:
          that.$dialog
            .alert({
              message: data.message
            })
            .then(() => {
              that.$router.push({ path: "/login" });
            });
          break;
        case 2:
            // 重新连接socket fd改变，客户端与服务端token相等时，不退出登入
          if (this.token == data.token) {
            return;
          }
          // 用户在别处登录，客服端与服务端token不相等时
          // 客户端token 与 后台token不相等时，退出登入
          window.localStorage.clear();
          that.$dialog
            .alert({
              message: data.message
            })
            .then(() => {
              // on close
              that.$router.push({ path: "/login" });
            });
          break;
        case 3:
          if (data.tag == "one") {
            this.friend_id = data.data.m_from_user_id;
            // 记录单聊未读消息数
            var unread = [];
            var unreads = JSON.parse(localStorage.getItem("unread"));
            if (!unreads) {
              var read = {
                friend_id: data.data.m_from_user_id,
                unreadNumber: 1
              };
              unread.push(read);
              localStorage.setItem("unread", JSON.stringify(unread));
            } else {
              var arr = [];
              unreads.forEach(element => {
                if (element.friend_id == data.data.m_from_user_id) {
                  ++element.unreadNumber;
                  localStorage.setItem("unread", JSON.stringify(unreads));
                }
                arr.push(element.friend_id);
              });
              if (arr.indexOf(data.data.m_from_user_id) <= -1) {
                var r = {
                  friend_id: data.data.m_from_user_id,
                  unreadNumber: 1
                };
                unreads.push(r);
                localStorage.setItem("unread", JSON.stringify(unreads));
              }
            }
            // 重新加载
            this.loadData();
            //播放声音
            var noDisturbing = localStorage.getItem(
              data.data.m_from_user_id + "noDisturbing"
            );
            if (that.u_id != data.data.m_from_user_id && noDisturbing != 1) {
              that.$refs.audio.currentTime = 0; //从头开始播放提示音
              that.$refs.audio.play(); //播放
            }
          }
          if (data.tag == "group") {
            this.group_id = data.ug_id;
            // 记录群聊未读消息数
            var groupunread = [];
            var groupunreads = JSON.parse(localStorage.getItem("groupUnread"));
            if (!groupunreads) {
              var read = {
                group_id: data.ug_id,
                unreadNumber: 1
              };
              groupunread.push(read);
              localStorage.setItem("groupUnread", JSON.stringify(groupunread));
            } else {
              var array = [];
              groupunreads.forEach(element => {
                if (element.group_id == data.ug_id) {
                  ++element.unreadNumber;
                  localStorage.setItem(
                    "groupUnread",
                    JSON.stringify(groupunreads)
                  );
                }
                array.push(element.group_id);
              });
              if (array.indexOf(data.ug_id) <= -1) {
                var r = {
                  group_id: data.ug_id,
                  unreadNumber: 1
                };
                groupunreads.push(r);
                localStorage.setItem(
                  "groupUnread",
                  JSON.stringify(groupunreads)
                );
              }
            }
            this.loadData();
            //播放声音
            var groupNoDistrrbing = localStorage.getItem(
              data.ug_id + "groupNoDistrrbing"
            );
            if (that.u_id != data.data.gm_from_id && groupNoDistrrbing != 1) {
              that.$refs.audios.currentTime = 0; //从头开始播放提示音
              that.$refs.audios.play(); //播放
            }
          }
          // 未读消息汇总
          var num = 0;
          var number = 0;
          var arr = JSON.parse(localStorage.getItem("unread"));
          if (array) {
            arr.forEach(element => {
              num += element.unreadNumber;
            });
          }
          var array = JSON.parse(localStorage.getItem("groupUnread"));
          if (array) {
            array.forEach(element => {
              number += element.unreadNumber;
            });
          }
          localStorage.setItem("countUnread", num + number);
          break;
      }
    },
    // 单聊天页面
    enterTheChat(friend_id, friend_name, m_post_messages,m_type1,duration) {
      console.log("11111111", friend_id, friend_name, m_post_messages,m_type1,duration);
      if (Array.isArray(m_post_messages) == true) {
        this.$dialog
          .confirm({
            title: "发送给：" + friend_name,
            message: "共转发：" + m_post_messages.length + "条信息"
          })
          .then(() => {
            this.$router.go(-1);
            // var m_post_messages1 = [];
            // for (let key in m_post_messages) {
            //   m_post_messages1.push(m_post_messages[key].m_post_messages || m_post_messages[key].gm_content);
            // }
            for (let c in m_post_messages) {
              var data = {
                message: m_post_messages[c].m_post_messages||m_post_messages[c].gm_content,
                friend_id: friend_id,
                u_id: this.u_id,
                mk: 1,
                type: m_post_messages[c].m_type || m_post_messages[c].ug_type,
                u_headportrait: this.userinfo["u_headportrait"],
                m_id: this.u_id + "_" + this.rannumber,
                duration:m_post_messages[c].duration,
              };
              ++this.rannumber;
              this.websocket.ws.send(JSON.stringify(data));
            }
          })
          .catch(() => {});
        } else {
        this.$dialog
          .confirm({
            title: "发送给：" + friend_name,
            message: m_post_messages
          })
          .then(() => {
            this.$router.push({
              name: "Chatroom",
              query: {
                friend_id: friend_id,
                friend_name: friend_name,
                transtat: this.transtat
              }
            });
             var data = {
              message:m_post_messages,
              friend_id: friend_id,
              u_id: this.u_id,
              mk: 1,
              type: this.m_type1,
              duration:this.duration,
              u_headportrait: this.userinfo["u_headportrait"],
              m_id: this.u_id + "_" + this.rannumber
            };
            ++this.rannumber;
            this.websocket.ws.send(JSON.stringify(data));
          })
          .catch(() => {});
      }
    },
    // 群聊天页面
    groupChatroom(id, ug_name, m_post_messages,m_type1) {
      if (Array.isArray(m_post_messages) == true) {
        this.$dialog
          .confirm({
            title: "发送给：" + ug_name,
            message: "共转发：" + m_post_messages.length + "条信息"
          })
          .then(() => {
             this.$router.go(-1);
            // var m_post_messages1 = [];
            // for (let key in m_post_messages) {
            //   m_post_messages1.push(m_post_messages[key].gm_content || m_post_messages[key].m_post_messages);
            // }
            for (let c in m_post_messages) {
              console.log(m_post_messages);
              var data = {
                message: m_post_messages[c].gm_content||m_post_messages[c].m_post_messages,
                ug_id: id,
                u_id: this.u_id,
                mk: 2,
                ug_type: m_post_messages[c].m_type || m_post_messages[c].ug_type,
                u_headportrait: this.userinfo["u_headportrait"],
                gm_id: this.u_id + "_" + this.rannumber,
                ug_admin_id: this.ug_admin_id,
                ug_group_nick: this.ug_group_nick,
                u_nickname: this.userinfo.u_nickname,
                u_login_id: this.userinfo.u_login_id,
                u_name: this.userinfo.u_name,
                duration:m_post_messages[c].duration,
              };
              ++this.rannumber;
              this.websocket.ws.send(JSON.stringify(data));
            }
          })
          .catch(() => {});
      } else {
        this.$dialog
          .confirm({
            title: "发送给：" + ug_name,
            message: m_post_messages
          })
          .then(() => {
            this.$router.push({
              name: "GroupChatroom",
              query: {
                ug_id: id,
                ug_name: ug_name,
                url: this.Conf.homeUrl,
                transtat: this.transtat
              }
            });
            var data = {
              message: m_post_messages,
              ug_id: id,
              u_id: this.u_id,
              mk: 2,
              ug_type: m_type1,
              u_headportrait: this.userinfo["u_headportrait"],
              gm_id: this.u_id + "_" + this.rannumber,
              ug_admin_id: this.ug_admin_id,
              ug_group_nick: this.ug_group_nick,
              u_nickname: this.userinfo.u_nickname,
              u_login_id: this.userinfo.u_login_id,
              u_name: this.userinfo.u_name,
              duration:this.duration,
            };
            ++this.rannumber;
            this.websocket.ws.send(JSON.stringify(data));
            // this.content = "";
          })
          .catch(() => {});
      }
    },
    transmsg(m_post_messages, ug_name) {
      console.log("111", m_post_messages, ug_name);
    },
    // 顶部搜索
    onClickSearch() {
      this.$router.push({
        name: "Search",
        query: {
          actionName: this.Conf.homeUrl
        }
      });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    // 发起群聊
    groupChat() {
      this.$router.push({
        name: "AddGroupChat",
        query: {
          actionName: "Chat",
          active: 0
          // url:"/"
        }
      });
    },
    // //以下为新添加；
    // socket连接，在此页面做重连用，初始化连接在登录页面
    localSocket() {
      let that = this;
      if ("WebSocket" in window) {
        console.log("您的浏览器支持 WebSocket!");
        // 实例化websocket连接
        var u_id = localStorage.getItem("u_id");
        var token = localStorage.getItem(u_id + "token");
        var ws_url = localStorage.getItem("ws_url");
        if (u_id && token && ws_url) {
          // 实例化websocket连接
          this.Socket = new WebSocket(
            ws_url + "?uid=" + u_id + "&token=" + token
          );
          // 注册进全局
          this.websocket.setWs(this.Socket);
          // 监听socket连接
          this.websocket.ws.onopen = this.open;
          // 监听socket错误信息
          this.websocket.ws.onerror = this.error;
          // 监听消息回调
          this.websocket.ws.onmessage = this.getMessage;
          // 监听连接关闭
          this.websocket.ws.onclose = this.close;
          console.log("Chat", "连接websocket");
        }
      } else {
        // 浏览器不支持 WebSocket
        // console.log("您的浏览器不支持 WebSocket!");
      }
    },
    //重新连接
    reconnect() {
      var that = this;
      if (that.lockReconnect) {
        return;
      }
      that.lockReconnect = true;
      //没连接上会一直重连，设置延迟避免请求过多
      that.timeoutnum && clearTimeout(that.timeoutnum);
      that.timeoutnum = setTimeout(function() {
        //新连接
        that.localSocket();
        that.loadData();
        that.lockReconnect = false;
      }, 2000);
    },
    //开启心跳
    start() {
      var self = this;
      clearInterval(window.timer);
      self.websocket.ws.send("heartCheck");
      window.timer = setInterval(function() {
        if (self.websocket.ws.readyState == 1) {
          console.log("chatroom", "发送心跳");
          self.websocket.ws.send("heartCheck");
        } else {
          this.loadLatestMsg();
          console.log("chatroom", "连接已经关闭");
          var u_id = localStorage.getItem("u_id");
          var token = localStorage.getItem(u_id + "token");
          var ws_url = localStorage.getItem("ws_url");
          if (u_id && token && ws_url) {
            this.reconnect();
          }
        }
      }, 20000);
    },
    // 监听socket连接
    open() {
      //开启心跳
      this.start();
      console.log("chat", "socket连接成功");
    },
    // 监听socket连接错误
    error() {
      //重连
      this.reconnect();
      console.log("chat", "发生错误socket重连");
    },
    // 监听socket连接关闭
    close(e) {
      var u_id = localStorage.getItem("u_id");
      var token = localStorage.getItem(u_id + "token");
      var ws_url = localStorage.getItem("ws_url");
      if (u_id && token && ws_url) {
        this.reconnect();
        console.log(
          "chat",
          "socket关闭重连" + e.code + " " + e.reason + " " + e.wasClean
        );
      }
    }
  }
};
</script>
<style lang="less" scoped>
.NewChat {
  .van-nav-bar {
    //  position:relative;
    z-index: 199;
  }
  .Chat {
    margin-top: 0px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Message/Newchat.vue